import React from "react";
import { Route, Routes } from "react-router-dom";
import Navbarmenu from "./components/menu/Navbarmenu";
import Layout from "./components/Layout/Layout";
import Contact from "./components/sections/Contact";
import Intro from "./components/Intro";

function App() {
  // return <Layout />;
  return (
    <>
      <Navbarmenu />
      <main>
        <Routes>
          <Route path="/" element={<Layout />} exact />
          <Route path="/intro" element={<Intro />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/about" component={About} />
      <Route path="/shop" component={Shop} /> */}
          {/* <Route component={Error} /> */}
        </Routes>
      </main>
    </>
  );
}

export default App;
